<template>
  <div>
    <div class="page f-pr">
		
	  <img src="../assets/bg-form.jpg" alt="" class="bg-img" />
	  
	  <div class="login-form">
		  <div class="input">
			  <input type="text" v-model="username" placeholder="姓名" maxlength="6"/>
		  </div>
		  <div class="input">
			  <input type="tel" v-model="phone"  placeholder="电话" maxlength="11"/>
		  </div>
		  <div class="btn-row fcc">
			  <button type="button" class="btn-submit fcc" @click="onSubmit">
				  <span id="">
				  	确认
				  </span>
			  </button>
		  </div>
	  </div>
     
    </div>



    <van-overlay :show="showLoading">
      <div class="fcc-h " style="height: 100vh;">
        <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>

import {mobileLogin} from "@/api/api";

export default {


  data() {
    return {
		  showLoading:false,
      username:null,
      phone:null
    };
  },
  async mounted() {
    
  },
  methods: {
		
		onSubmit(){
      let data={username:this.username,phone:this.phone}
      if(!data.username) this.$toast('请填写用户名')
      if(!data.phone) this.$toast('请填写手机号')
      mobileLogin(data).then(res=>{
        if(res.success){
          this.$router.push({path:'/sign'})
          window.localStorage.setItem('mobile', data.phone)
        }else{
          this.$toast(res.msg)
        }
      })
		}

  },
};
</script>
<style scoped lang="less">
	.page{
		min-height: 100vh;
		background: url(../assets/bg-form.jpg)  center bottom no-repeat;
	}
</style>
